import Router from 'vue-router'
import myPersonalRouter from './map/my-personal'
import router from './map/routers'
import { Message } from 'element-ui';
const ROUTER = new Router({
  mode: 'hash',
  base: __dirname,
  linkActiveClass: 'active',
  routes: [
    ...myPersonalRouter,
    ...router
  ]
})

ROUTER.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let isLogin = window.localStorage.getItem("isLogin");
  if (isLogin) {
    next();
  } else {
    if (to.path != '/' &&
      to.path != '/index' &&
      to.path != '/home' &&
      to.path != '/login' &&
      to.path != '/client_registering' &&
      to.path != '/client_logining' &&
      to.path != '/client_balance' &&
      to.path != '/client_vip_card_active' &&
      to.path != '/tfedu_common/register' &&
      to.path != '/tfedu_common/team' &&
      to.path != '/download' &&
      to.path != '/photo_upload/index' &&
      to.path != '/register/argeement' &&
      to.path != '/reterieve_password' &&
      to.path != '/radio_question' && 
      to.path != '/select_subject' &&
      to.path != '/paper/pad_paper' && 
      to.path != '/tfedu_common/expert' &&
      to.path != '/tfedu_common/home' &&
      to.path != '/tfedu_common/help' &&
      to.path != '/tfedu_common/buy_members' &&
      to.path != '/shopping_mall' &&
      to.path != '/shopping_registering' &&
      to.path != '/web_login' &&
      to.path != '/web_order' &&
      to.path != '/web_login_register' &&
      to.path != '/web/setting' &&
      to.path != '/web/purchased' &&
      to.path != '/web_reterieve_password'
    ) {
      Message.info('未登录,请先登录!');
    } else {
      next();
    }
  }
});

export default ROUTER


